(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTORS = '[data-reveal]';
  var AUTO_SELECTORS = [
    '#MainContent .section-header',
    '#MainContent .title-wrapper',
    '#MainContent .products-grid-section__heading',
    '#MainContent .collection-product-card',
    '#MainContent .article-card',
    '#MainContent .blog__post',
    '#MainContent .product-recommendations__heading',
    '#MainContent .product-recommendations__product',
    '#MainContent .product-recommendations__list .swiper-slide',
    '#MainContent .image-with-text__media',
    '#MainContent .image-with-text__content',
    '#MainContent .rich-text__blocks',
    '#MainContent .newsletter__inner',
    '#MainContent .page-section .page-header',
    '#MainContent .page-section .main-page-title',
    '#MainContent .page-section .rte > *',
    '#MainContent .shopify-policy__title',
    '#MainContent .shopify-policy__body > *',
    '#MainContent .faq-section__heading',
    '#MainContent .faq-item',
    '#MainContent .collapsible-content__top',
    '#MainContent .collapsible-content__item',
    '#MainContent .contact-form__header',
    '#MainContent .contact-form .field',
    '#MainContent .contact-form__bottom',
    '#MainContent .contact-form__contacts',
    '#MainContent .product__gallery-viewer',
    '#MainContent .product__info-container',
    '#MainContent .product__description-section',
    '#MainContent .product-meta-block',
    '#MainContent .layer-pass-content__row',
    '#MainContent .game-assets-card',
    '#MainContent .game-assets-products__item',
    '#MainContent .game-assets-v2-features__item'
  ].join(',');
  var AUTO_EXCLUDE_SELECTOR = [
    '.shopify-section-header',
    '.product-sticky-cta-price',
    '.product-sticky-cta-sentinel',
    '.collection-tabs',
    '.collection-tabs *',
    '.facets',
    '.facets *',
    '.facets-container',
    '.facets-container *',
    '.mobile-facets__wrapper',
    '.mobile-facets__wrapper *',
    '.cart-drawer',
    '.drawer',
    '.modal',
    '.popup',
    '.predictive-search',
    '.jdgm-widget',
    '.jdgm-widget *'
  ].join(',');

  var STAGGER_MS = 55;
  var STAGGER_CAP_MS = 880;
  var ROW_TOLERANCE = 24;

  var io = null;
  var tracked = new WeakSet();
  var queued = new WeakSet();
  var visibleQueue = [];
  var flushScheduled = false;

  function reveal(el, delay) {
    var customDelay = parseInt(el.dataset.revealDelay || '0', 10);
    var finalDelay = delay + (Number.isFinite(customDelay) ? customDelay : 0);
    el.style.transitionDelay = finalDelay + 'ms';
    el.classList.add('is-visible');
    if (io) io.unobserve(el);
    el.addEventListener('transitionend', function onEnd() {
      el.classList.add('reveal-done');
      el.style.transitionDelay = '';
      el.removeEventListener('transitionend', onEnd);
    });
  }

  function showInstant(el) {
    el.classList.add('is-visible', 'reveal-done');
    tracked.add(el);
  }

  function sortByVisualPosition(elements) {
    return elements.sort(function (a, b) {
      var rectA = a.getBoundingClientRect();
      var rectB = b.getBoundingClientRect();
      var topDelta = rectA.top - rectB.top;

      if (Math.abs(topDelta) > ROW_TOLERANCE) return topDelta;
      return rectA.left - rectB.left;
    });
  }

  function flushVisibleQueue() {
    flushScheduled = false;
    var visible = sortByVisualPosition(visibleQueue.splice(0));

    visible.forEach(function (el, idx) {
      reveal(el, Math.min(idx * STAGGER_MS, STAGGER_CAP_MS));
    });
  }

  function queueVisible(el) {
    if (queued.has(el)) return;
    queued.add(el);
    visibleQueue.push(el);

    if (!flushScheduled) {
      flushScheduled = true;
      requestAnimationFrame(flushVisibleQueue);
    }
  }

  function ensureObserver() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;

    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) queueVisible(entries[i].target);
      }
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.04
    });
    return io;
  }

  function canAutoReveal(el) {
    if (!el || el.dataset.noReveal !== undefined || el.dataset.reveal !== undefined) return false;
    if (AUTO_EXCLUDE_SELECTOR && el.closest(AUTO_EXCLUDE_SELECTOR)) return false;
    if (el.closest('[data-no-reveal]')) return false;
    return true;
  }

  function getElementsIncludingRoot(root, selector) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = [];

    if (scope !== document && scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }

    scope.querySelectorAll(selector).forEach(function (el) {
      elements.push(el);
    });

    return elements;
  }

  function markAutoReveal(root) {
    var targets = getElementsIncludingRoot(root, AUTO_SELECTORS);

    targets.forEach(function (el) {
      if (!canAutoReveal(el)) return;
      el.setAttribute('data-reveal', 'auto');
    });
  }

  function getRevealElements(root) {
    return getElementsIncludingRoot(root, SELECTORS);
  }

  function init(root) {
    markAutoReveal(root);

    var els = getRevealElements(root);
    if (!els.length) return;
    var observer = ensureObserver();

    els.forEach(function (el) {
      if (tracked.has(el)) return;

      var rect = el.getBoundingClientRect();
      tracked.add(el);

      if (!observer || rect.bottom < 0) {
        showInstant(el);
        return;
      }

      observer.observe(el);
    });
  }

  function observeForReveal(el) {
    if (tracked.has(el)) return;
    tracked.add(el);
    var observer = ensureObserver();
    if (observer) {
      observer.observe(el);
    } else {
      showInstant(el);
    }
  }

  function observeAllNew(root) {
    markAutoReveal(root);
    getRevealElements(root).forEach(function (el) {
      if (!tracked.has(el)) observeForReveal(el);
    });
  }

  function watchInsertions() {
    if (typeof MutationObserver !== 'function') return;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.matches && node.matches(SELECTORS) && !tracked.has(node)) {
            observeForReveal(node);
          }
          if (node.querySelectorAll) {
            observeAllNew(node);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      watchInsertions();
    });
  } else {
    init();
    watchInsertions();
  }

  document.addEventListener('shopify:section:load', function (e) { observeAllNew(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { observeAllNew(e.target); });
})();

(function () {
  function scheduleIdle(callback) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout: 2600 });
    } else {
      setTimeout(callback, 1600);
    }
  }

  function warmImage(image) {
    if (!image || image.dataset.idleWarmed === 'true') return;
    image.dataset.idleWarmed = 'true';
    image.loading = 'eager';
    image.decoding = 'async';
    image.fetchPriority = 'low';
  }

  function warmDeferredMedia() {
    var body = document.body;
    if (!body) return;

    var selectors = [];

    if (body.classList.contains('template-index')) {
      selectors.push(
        '#MainContent .section-products-grid img[loading="lazy"]',
        '#MainContent .section-featured-blog img[loading="lazy"]'
      );
    }

    if (body.classList.contains('template-blog') || body.classList.contains('template-article')) {
      selectors.push(
        '#MainContent .main-blog__articles img[loading="lazy"]',
        '#MainContent .article-template img[loading="lazy"]'
      );
    }

    if (!selectors.length) return;

    document.querySelectorAll(selectors.join(',')).forEach(warmImage);
  }

  if (document.readyState === 'complete') {
    scheduleIdle(warmDeferredMedia);
  } else {
    window.addEventListener('load', function () {
      scheduleIdle(warmDeferredMedia);
    }, { once: true });
  }
})();
